const finiteNumberOrNull = (value) => {
     if (value === null || value === undefined || value === "") return null;
     const normalized = typeof value === "string" ? value.trim().replace(",", ".") : value;
     const parsed = Number(normalized);
     return Number.isFinite(parsed) ? parsed : null;
};

export const isPriceAdjustmentRuleConfigured = (rule) => {
     if (!rule) return false;
     const hasComparison = !!rule.ComparisonOption;
     const hasActions =
          Array.isArray(rule.action) &&
          rule.action.some(
               (formula) =>
                    (finiteNumberOrNull(formula?.priceUntil) !== null && finiteNumberOrNull(formula?.underBidAmount) !== null) ||
                    (formula?.priceType != null && finiteNumberOrNull(formula?.underBidAmount) !== null)
          );
     return hasComparison || hasActions;
};

export const createEmptyPriceAdjustmentDraft = (extendedPriceChange = false) => ({
     active: false,
     priceChangeAsCoupon: false,
     typeOfPriceChangeInEuro: false,
     ComparisonOption: null,
     action: extendedPriceChange
          ? [{ priceType: null, underBidAmount: null, condition: null }]
          : [{ priceUntil: null, underBidAmount: null }],
});

export const resolvePriceAdjustmentModalRuleId = ({
     isEditing,
     editingRuleId,
     existingRules,
     sessionDraftId,
}) => {
     const rules = Array.isArray(existingRules) ? existingRules : [];
     if (isEditing && editingRuleId) {
          return rules.some((rule) => rule.id === editingRuleId) ? editingRuleId : null;
     }
     if (sessionDraftId && rules.some((rule) => rule.id === sessionDraftId)) {
          return sessionDraftId;
     }
     return null;
};

export const staleInactivePriceAdjustmentIds = (existingRules, sessionDraftId) => {
     return (Array.isArray(existingRules) ? existingRules : [])
          .filter((rule) => !rule.active && rule.id !== sessionDraftId)
          .map((rule) => rule.id);
};

export const withoutInactivePriceAdjustments = (snapshot) => {
     if (!snapshot?.actionRuleData) {
          return snapshot;
     }

     const remaining = (snapshot.actionRuleData.priceAdjustmentRules || []).filter((rule) => rule.active);
     const activeIdStillExists = remaining.some((rule) => rule.id === snapshot.activePriceAdjustmentRuleId);

     return {
          ...snapshot,
          actionRuleData: {
               ...snapshot.actionRuleData,
               priceAdjustmentRules: remaining,
          },
          activePriceAdjustmentRuleId: activeIdStillExists
               ? snapshot.activePriceAdjustmentRuleId
               : remaining[0]?.id ?? null,
     };
};

export const PRICE_CHANGE_CATEGORY_ID = 1;
export const MARGIN_CATEGORY_ID = 4;

export const availableActionCategories = ({
     categories,
     editingCategoryId = null,
     activeCategoryIds = [],
     hasMarginComponent = false,
     hasPriceChangeComponent = false,
}) => {
     const list = Array.isArray(categories) ? categories : [];
     const active = new Set(activeCategoryIds);

     if (editingCategoryId !== null && editingCategoryId !== undefined) {
          return list.filter((category) => category.id === editingCategoryId);
     }

     return list.filter((category) => {
          if (active.has(category.id)) {
               return false;
          }
          if (category.id === PRICE_CHANGE_CATEGORY_ID && hasMarginComponent) {
               return false;
          }
          if (category.id === MARGIN_CATEGORY_ID && hasPriceChangeComponent) {
               return false;
          }
          return true;
     });
};

